import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "top-bar view-mode-comp" }
const _hoisted_2 = ["value"]
const _hoisted_3 = { class: "btn-group movie-search-btn-wrap" }
const _hoisted_4 = { class: "btn-group" }
const _hoisted_5 = { class: "dropdown-menu" }
const _hoisted_6 = { class: "dropdown-item disabled ft-bold" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "btn-group" }
const _hoisted_9 = { class: "dropdown-menu" }
const _hoisted_10 = { class: "dropdown-item disabled ft-bold" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  class: "btn-group btn-group-toggle ws-nowrap",
  style: {"margin-top":"-1px"}
}
const _hoisted_13 = ["checked", "onClick"]
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "btn-group movie-search-btn-wrap" }
const _hoisted_16 = { class: "btn-group" }
const _hoisted_17 = { class: "dropdown-menu" }
const _hoisted_18 = { class: "dropdown-item disabled ft-bold" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "btn-group" }
const _hoisted_21 = { class: "dropdown-menu" }
const _hoisted_22 = { class: "dropdown-item disabled ft-bold" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "toggle-button mr16" }
const _hoisted_25 = { class: "btn-group btn-group-toggle ws-nowrap" }
const _hoisted_26 = { class: "btn btn-info btn-sm" }

import type { GIMovieList } from 'src/models/geoItem';
import type { CameraPosition } from 'src/models/movie';
import type { LeftRight } from 'src/models/moviePlayer';
import { dtFormat } from 'src/lib/dateHelper';
import {
  MOVIE_BACK_DATE_CHOICES,
  MOVIE_FORWARD_DATE_CHOICES,
} from 'src/components/lib/MoviePlayerCompareMode/composables/useMoviePlayerCompareModeState';

interface Props {
  leftMovieLists: GIMovieList[];
  rightMovieLists: GIMovieList[];
  leftBaseDate: Date | null;
  rightBaseDate: Date | null;
  selectedCameraPosition: CameraPosition;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CompareModeTopBar',
  props: /*@__PURE__*/_mergeModels({
    leftMovieLists: {},
    rightMovieLists: {},
    leftBaseDate: {},
    rightBaseDate: {},
    selectedCameraPosition: {}
  }, {
    "leftMovieListId": { required: true },
    "leftMovieListIdModifiers": {},
    "rightMovieListId": { required: true },
    "rightMovieListIdModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["change-movie-list-id", "search-by-date-range", "change-camera-position", "switch-to-full-mode", "close"], ["update:leftMovieListId", "update:rightMovieListId"]),
  setup(__props: any) {



const cameraPositions: Array<{ camPos: CameraPosition; disp: string }> = [
  { camPos: 'left', disp: '左' },
  { camPos: 'front', disp: '正面' },
  { camPos: 'right', disp: '右' },
];

const leftMovieListId = _useModel<string>(__props, 'leftMovieListId');
const rightMovieListId = _useModel<string>(__props, 'rightMovieListId');



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((leftMovieListId).value = $event)),
        class: "custom-select ml-select ib",
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change-movie-list-id', 'left')))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.leftMovieLists, (e) => {
          return (_openBlock(), _createElementBlock("option", {
            key: e.id,
            value: e.id
          }, _toDisplayString(e.dateLocationCarDisp), 9, _hoisted_2))
        }), 128))
      ], 544), [
        [_vModelSelect, leftMovieListId.value]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[7] || (_cache[7] = _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            "data-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false"
          }, [
            _createElementVNode("i", { class: "fas fa-angle-double-left fa-lg" })
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(dtFormat)(__props.leftBaseDate, 'yyyy/mm/dd')), 1),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MOVIE_BACK_DATE_CHOICES), (v, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "dropdown-item",
                key: i,
                onClick: ($event: any) => (_ctx.$emit('search-by-date-range', 'left', v.key))
              }, _toDisplayString(v.val), 9, _hoisted_7))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[9] || (_cache[9] = _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            "data-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false"
          }, [
            _createElementVNode("i", { class: "fas fa-angle-double-right fa-lg" })
          ], -1)),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(dtFormat)(__props.leftBaseDate, 'yyyy/mm/dd')), 1),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MOVIE_FORWARD_DATE_CHOICES), (v, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "dropdown-item",
                key: i,
                onClick: ($event: any) => (_ctx.$emit('search-by-date-range', 'left', v.key))
              }, _toDisplayString(v.val), 9, _hoisted_11))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cameraPositions, (e, i) => {
          return _createElementVNode("label", {
            class: _normalizeClass(["btn btn-info btn-md", {active: __props.selectedCameraPosition === e.camPos}]),
            key: i
          }, [
            _createElementVNode("input", {
              type: "radio",
              name: "options",
              checked: __props.selectedCameraPosition === e.camPos,
              autocomplete: "off",
              onClick: ($event: any) => (_ctx.$emit('change-camera-position', e.camPos))
            }, null, 8, _hoisted_13),
            _createTextVNode(_toDisplayString(e.disp), 1)
          ], 2)
        }), 64))
      ]),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((rightMovieListId).value = $event)),
        class: "custom-select ml-select ib",
        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('change-movie-list-id', 'right')))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rightMovieLists, (e) => {
          return (_openBlock(), _createElementBlock("option", {
            key: e.id,
            value: e.id
          }, _toDisplayString(e.dateLocationCarDisp), 9, _hoisted_14))
        }), 128))
      ], 544), [
        [_vModelSelect, rightMovieListId.value]
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _cache[11] || (_cache[11] = _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            "data-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false"
          }, [
            _createElementVNode("i", { class: "fas fa-angle-double-left fa-lg" })
          ], -1)),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(dtFormat)(__props.rightBaseDate, 'yyyy/mm/dd')), 1),
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MOVIE_BACK_DATE_CHOICES), (v, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "dropdown-item",
                key: i,
                onClick: ($event: any) => (_ctx.$emit('search-by-date-range', 'right', v.key))
              }, _toDisplayString(v.val), 9, _hoisted_19))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _cache[13] || (_cache[13] = _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            "data-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false"
          }, [
            _createElementVNode("i", { class: "fas fa-angle-double-right fa-lg" })
          ], -1)),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(dtFormat)(__props.rightBaseDate, 'yyyy/mm/dd')), 1),
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MOVIE_FORWARD_DATE_CHOICES), (v, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "dropdown-item",
                key: i,
                onClick: ($event: any) => (_ctx.$emit('search-by-date-range', 'right', v.key))
              }, _toDisplayString(v.val), 9, _hoisted_23))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("label", _hoisted_26, [
          _createElementVNode("input", {
            type: "radio",
            name: "options",
            autocomplete: "off",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('switch-to-full-mode')))
          }),
          _cache[14] || (_cache[14] = _createTextVNode("三面 ", -1))
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "btn btn-info btn-sm active" }, [
          _createElementVNode("input", {
            type: "radio",
            name: "options",
            checked: "",
            autocomplete: "off"
          }),
          _createTextVNode("比較 ")
        ], -1))
      ])
    ]),
    _createElementVNode("div", {
      class: "close-button",
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
    }, [...(_cache[16] || (_cache[16] = [
      _createElementVNode("i", { class: "fas fa-times fa-2x" }, null, -1)
    ]))])
  ], 64))
}
}

})